import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingSirenRnaRequiredFR: {
    id: 'charity.vetting.fr.siren.rna.required',
    defaultMessage: 'Please enter your SIREN or RNA number before you continue.',
  },
  charityVettingSirenWrongFormatFR: {
    id: 'charity.vetting.fr.siren.wrong.format',
    defaultMessage: 'Invalid format. The SIREN number must contain 9 digits.',
  },
  charityVettingSirenTitleFR: {
    id: 'charity.vetting.fr.siren.title',
    defaultMessage: "Add your organisation's SIREN and/or RNA number",
  },
  charityVettingSirenLabelFR: {
    id: 'charity.vetting.fr.siren.label',
    defaultMessage: 'SIREN number',
  },
  charityVettingDialogSirenAndRnaTitleFR: {
    id: 'charity.vetting.fr.dialog.siren.rna.title',
    defaultMessage: 'SIREN and RNA number',
  },
  charityVettingDialogSirenAndRnaTextFR: {
    id: 'charity.vetting.fr.dialog.siren.rna.text',
    defaultMessage:
      "If you're unsure of your organisation's SIREN or RNA number, you can find them using the links below.",
  },
  charityVettingDialogSirenAndRnaLinkTextFR: {
    id: 'charity.vetting.fr.dialog.siren.rna.link.text',
    defaultMessage: 'Find your SIREN number',
  },
  charityVettingDialogSirenAndRnaLinkText2FR: {
    id: 'charity.vetting.fr.dialog.siren.rna.link.text.2',
    defaultMessage: 'Find your RNA number',
  },
  charityVettingRnaLabelFR: {
    id: 'charityVetting.fr.rna.label',
    defaultMessage: 'RNA number',
  },
  charityVettingDialogRnaHelperTextFR: {
    id: 'charity.vetting.fr.dialog.rna.helper.text',
    defaultMessage:
      "*If your organisation is registered in Alsace-Moselle, please use the registration number from your District Court's Register of Associations.",
  },
});
